export default __webpack_public_path__ + "static/media/surfboard_light.e924743f.png";